module.exports = __webpack_public_path__ + "img/touch-icon.d284ba59.png";